import Breadcrumbs from "@mui/material/Breadcrumbs";
import Box from "@mui/material/Box";
// import Box from "@mui/material/Box";
import Link from "next/link";
import useWindowSize from "../../_hooks/useWindowSize";
// import { isDefined } from "../../config/helpers";
import { useSelector } from "react-redux";
// import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import DoubleArrow from '@mui/icons-material/KeyboardDoubleArrowRightOutlined';
import HomeIcon from '@mui/icons-material/Home';
import dynamic from "next/dynamic";
import React from "react";

const BoxContainer = dynamic(() => import('../Reusables/BoxContainerV2'));
const boxStyles = {
    marginTop: {
        xs: '1rem',
        lg: 0,
    },
    marginLeft: {
        xs: '0.5rem',
        lg: 0,
    },
};

const breadcrumbsStyles = {
    '& .MuiBreadcrumbs-separator': {
        marginLeft: 0,
        marginRight: '5px',
    },
};


const Breadcrumb = (props) => {
    
    const breadcrumbs = useSelector(state => state.globalReducer.breadcrumbs);
    const template_settings = useSelector(state => state.globalReducer.template_settings);

    const layout = template_settings.layout;
    const {isMobile, width} = useWindowSize();

    //const var to remove margin if we have a sidenav
    const page_sidenav = (props?.data?.template_page_settings && props?.data?.template_page_settings?.sidenav == 'yes' && (width > 1200 || !isMobile)) ? true : false

    const {
        links,
        last 
    } = breadcrumbs;

    const hasNoSideNav = props?.data?.template_page_settings?.sidenav === 'no';
    const isSideNavUndefined = !props?.data?.template_page_settings || 
                                !props?.data?.template_page_settings?.sidenav;
    const isBoxLayout = layout === 'box';
    const isWideOrMobile = width > 1200 || isMobile;

    const shouldApplyBoxedPadding = (hasNoSideNav || isSideNavUndefined) && (isBoxLayout && isWideOrMobile) || isMobile;
    const paddingClass = shouldApplyBoxedPadding ? 'boxed-padding mt-0' : page_sidenav ? '' : 'pl-2 pr-2';

    const className = `${paddingClass} mb-3`;

    const renderBreadcrumbs = (links, last) => {
        const breadcrumbItems = [];
    
        breadcrumbItems.push(
            <Link shallow={true} href="/" key="home">
                <HomeIcon fontSize="medium" color="primary" />
            </Link>
        );
    
        Object.entries(links).forEach(([route, url], index) => {
            breadcrumbItems.push(
                <Link shallow={true} key={index} href={url}>
                    {route}
                </Link>
            );
        });
        
        breadcrumbItems.push(<span key="last">{last}</span>);
        return breadcrumbItems;
    };

    return (
        <Box sx={{backgroundColor: '#e7e9eb'}}>
            <BoxContainer className="mb-3" mobileClasses={'pl-2 pr-2'} >
                <Breadcrumbs 
                    className="text-vertical"
                    sx={breadcrumbsStyles}
                    separator={<DoubleArrow fontSize="small" className="" sx={{ padding: 0.2 }} />}
                    aria-label="breadcrumb"
                >
                    {renderBreadcrumbs(links, last)}
                </Breadcrumbs>
            </BoxContainer>
        </Box>
    );
};

export default React.memo(Breadcrumb);
